export default __webpack_public_path__ + "static/media/config-purple.822a81b0.svg";